import { ConditionMedia } from './condition-media';

export class ConditionFilterMediaLog {
  id: Number;
  email: String;
  registrationIds: Array<string>;
  condition: ConditionMedia;
  period: number;
  dateFrom: string;
  dateTo: string;
  playlistNames: Array<string>;

  constructor(email?: String, period?: number) {
    this.email = email;
    this.period = period;
  }
}
